import {createElements, userPrevent, createHtmlElement} from "../../functions";
import {isMobile, settingsData} from "../../settings";
import {ViewMode} from "../../common";
import {openSearchHandler} from "../search/search";
import { menuHandler, mobileBurgerStyleToggle, setMenuActive } from '../menu/menu';
import { changeLangToCurrent, isDesktopMode } from '../language/langSwitcher';
import gsap from "gsap";
import QRCode from 'qrcode';
import { setLordIcon } from '../../lordicon';

export const openGetApp =  async () => {
    const {qrCodeUrl,appStoreUrl,googlePlayUrl} = config.getApp;

    if (isMobile){
        const prevActiveMenu = document.querySelector('.aside__active-menu').getAttribute('data-menu-item');
        window.open(qrCodeUrl,'_blank');
        setTimeout(()=> {
            menuHandler({target:{dataset:{menuItem: prevActiveMenu}}},config.general);
        },300);
        return;
    }

    const getApp = await createGetApp(qrCodeUrl,appStoreUrl,googlePlayUrl);

    if (!isMobile){
        openAndCloseAnimation('open');
    }
}

export const removeGetApp = (speed) => {
    const getAppBlock = document.querySelector('.get-app');

    if (speed === 'immediately') {
        document.body.removeChild(getAppBlock);
        return;
    }

    if (getAppBlock){
        openAndCloseAnimation('close');
        if (settingsData.activeViewMode === ViewMode.Cylinder || settingsData.activeViewMode === ViewMode.FloorPlan ){
            if (!isMobile){
                openSearchHandler();
            }
            setMenuActive('search')
        } else if (settingsData.activeViewMode === ViewMode.Orbit){
            setMenuActive('3dModel')
        }
    }
};


function openAndCloseAnimation(action) {
    const contactUsBlock = document.querySelector('.get-app');
    const importantDirection = isDesktopMode();
    const rtl = document.querySelector('html').getAttribute('dir') === 'rtl';
    let menuWidth = document.querySelector('.aside__container').getBoundingClientRect().width;
    let menuHeight = document.querySelector('.aside__container').getBoundingClientRect().height;

    if (importantDirection){
        menuWidth = 0;
    }

    const tl = gsap;
    const direction = {};

    switch (action) {
        case 'open':
            if (importantDirection){
                direction.from = {
                    left:  'initial',
                    right: '-100%',
                    height: `${window.innerHeight - menuHeight}px`
                };
                direction.to = {
                    left: 'initial',
                    right: `${menuWidth}px`,
                    height: `${window.innerHeight - menuHeight}px`
                };

            } else {
                direction.from = {
                    left: rtl ? 'initial' : '-100%',
                    right: rtl ? '-100%' : 'initial',
                    height: `${menuHeight}px`
                };
                direction.to = {
                    left: rtl ? 'initial' : `${menuWidth}px`,
                    right: rtl ? `${menuWidth}px` : 'initial',
                    height: `${menuHeight}px`
                };
            }
            break;
        case 'close':
            if (importantDirection){
                direction.from = {
                    left:  'initial',
                    right: `${menuWidth}px`,
                    height: `${window.innerHeight - menuHeight}px`,
                };
                direction.to = {
                    left: 'initial',
                    right: `-100%`,
                    height: `${window.innerHeight - menuHeight}px`,
                    complete: true
                };
            } else {
                direction.from = {
                    left: rtl ? 'initial' : `${menuWidth}px`,
                    right: rtl ? `${menuWidth}px` : 'initial',
                    height: `${menuHeight}px`,
                };
                direction.to = {
                    left: rtl ? 'initial' : '-100%',
                    right: rtl ? '-100%' : 'initial',
                    height: `${menuHeight}px`,
                    complete: true,
                };
            }
            break;
    }

    return new Promise(resolve => {
        tl.fromTo(contactUsBlock,  {
            left: direction.from.left,
            right: direction.from.right,
            // height: direction.to.height,
            direction: .5,
        }, {
            left: direction.to.left,
            right: direction.to.right,
            // height: direction.to.height,
            direction: .5,
            onStart: ()=>{
                userPrevent(true);
            },
            onComplete: () => {
                if (direction.to.complete) {
                    substrateToggle('hide');
                    contactUsBlock.parentNode !== null && document.body.removeChild(contactUsBlock);
                    isMobile && mobileBurgerStyleToggle();
                } else {
                    substrateToggle('show');
                }
                userPrevent(false);
                resolve();
            },
        });

    });
}

function substrateToggle (action) {
    const substrate = document.querySelector('.aside__open-menu__substrate');

    switch (action) {
        case 'hide': substrate.classList.remove('substrate__show');
            break;
        case 'show': substrate.classList.add('substrate__show');
            break;
    }
}

async function createGetApp(qrCode,appStoreLink,googlePlayLink) {
    const main = createHtmlElement(document.body,'','div',['get-app']);
    const contentContainer = createHtmlElement(main,'','div',['get-app__content-container']);
    const closeBtn = createHtmlElement(main,'','button',['get-app__close-button', 'button', 'icon-close']);

    if (!qrCode && !appStoreLink && !googlePlayLink){
        closeBtn.addEventListener('click', removeGetApp, {once: true});
        return;
    }

    if (isDesktopMode()){
        const title = createHtmlElement(contentContainer,changeLangToCurrent('getAppTitleDesktop'),'h2',['get-app__title','language-string']);
        title.setAttribute('data-dictionary', 'getAppTitleDesktop');
    } else {
        const title = createHtmlElement(contentContainer,changeLangToCurrent('getAppTitle'),'h2',['get-app__title','language-string']);
        title.setAttribute('data-dictionary', 'getAppTitle');
    }

    if (qrCode){

        const scanIcon = createHtmlElement(contentContainer,'','div',['get-app__scan__icon']);
        setLordIcon('scanIcon',scanIcon,{
            stroke: 70
        });
        const qrCodeWrapper = createHtmlElement(contentContainer,'','div',['get-app__qr-code__wrapper']);

        await QRCode.toDataURL(qrCode, function (err, url) {
            qrCodeWrapper.style.backgroundImage = `url(${url})`;
        });
    }

    const btnWrapper = createHtmlElement(contentContainer,'','div',['get-app__btn-container']);

    if (isDesktopMode()){
        btnWrapper.classList.add('hidden');
    }

    if (appStoreLink){
        const iosLink = createHtmlElement(btnWrapper,'','a',['get-app__link']);
        iosLink.href=appStoreLink;
        iosLink.setAttribute('target','_blank');
        const iosBtn = createHtmlElement(iosLink,'','img',['get-app__btn']);
        iosBtn.src='./img/appstore_button.svg';
    }

    if (googlePlayLink){
        const androidLink = createHtmlElement(btnWrapper,'','a',['get-app__link']);
        androidLink.href=googlePlayLink;
        androidLink.setAttribute('target','_blank');
        const androidBtn = createHtmlElement(androidLink,'','img',['get-app__btn']);
        androidBtn.src='./img/google_play_button.svg';
    }

    closeBtn.addEventListener('click', removeGetApp, {once: true});

    return main;
}


export const changeGetAppModulePosition = () => {
    const mainContainer = document.querySelector('.get-app');

    if (!mainContainer) return;

    const menuContainer = document.querySelector('.aside__container');
    const currentDirection = document.documentElement.getAttribute('dir');
    const menuContainerWidth = +menuContainer.getAttribute('data-initial-width');

    switch (currentDirection) {
        case 'rtl': {
            mainContainer.removeAttribute('style');
            mainContainer.setAttribute('style', `right:${menuContainerWidth}px`);
            break;
        }
        case 'ltr': {
            mainContainer.removeAttribute('style');
            mainContainer.setAttribute('style', `left:${menuContainerWidth}px`);
            break;
        }
        default:
            break;
    }

    removeGetApp('immediately');
    openGetApp();
};
